const arr = [{
    id: 1,
    rank: 4.5,
    comments: "，YYDS!!!!",
    timeDesc: "4月16日17时21分",
    pov: "陕西省",
    email: "****9288@qq.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 2,
    rank: 4,
    comments: "给我的第一反应，原来充值卡洗货比跑分更赚钱，从新人LV1现在已经合作了一年时间。相信末来发展会越走越好。",
    timeDesc: "4月15日9时4分",
    pov: "陕西省",
    email: "****nane@sina.com",
    avatar: require("../../images/reviews/avatar2.png")
  },
  {
    id: 3,
    rank: 5,
    comments: "很给力的一个跑货网站，以前跑过分，上家跑路之后就一直没有找到好的项目，现在终于又找到了出路。还有感谢的客服耐心帮助我。",
    timeDesc: "4月14日9时24分",
    pov: "江苏省",
    email: "****4658@qq.com",
    avatar: require("../../images/reviews/avatar3.png")
  },
  {
    id: 4,
    rank: 5,
    comments: "如今跑分跑货市场鱼龙混杂，之前被骗了很多次，来这个平台也是想着先试试看，结果给了我意想不到的惊喜！买卡后的卡密没有一张是失效的，全部正常兑换套现。给力给...",
    timeDesc: "4月13日23时55分",
    pov: "广西壮族自治区",
    email: "****atic@sina.com",
    avatar: require("../../images/reviews/avatar4.png")
  },
  {
    id: 5,
    rank: 3.5,
    comments: "客服耐心真的好，开始我还以为是温柔的陷阱，没想到这个给力",
    timeDesc: "4月13日21时47分",
    pov: "云南省",
    email: "****nane@sina.com",
    avatar: require("../../images/reviews/avatar3.png")
  },
  {
    id: 6,
    rank: 4.5,
    comments: "最开始还怕被骗，想着10张卡也就几百块钱试试的心态，没想到真找到了一个靠谱的跑货平台。爽呆了！ ",
    timeDesc: "4月13日0时47分",
    pov: "甘肃省",
    email: "****nane@sina.com",
    avatar: require("../../images/reviews/avatar3.png")
  },
  {
    id: 7,
    rank: 5,
    comments: "这个网站帮助了我从负责累累到财富自由。不解释。 ",
    timeDesc: "4月13日0时26分",
    pov: "广西壮族自治区",
    email: "****nane@sina.com",
    avatar: require("../../images/reviews/avatar2.png")
  },
  {
    id: 8,
    rank: 4.5,
    comments: "现在的年轻人都玩抖音短视频，可是真正赚钱的没几个人，的洗货模式一定是小资赚钱发展的趋势，当你看到不要犹豫立即加入。 ",
    timeDesc: "4月11日21时28分",
    pov: "内蒙古自治区",
    email: "****omed@hotmail.com",
    avatar: require("../../images/reviews/avatar4.png")
  },
  {
    id: 9,
    rank: 3.5,
    comments: "简直是难以置信，可以当成一种职业赚钱，我和朋友已经加入到洗货中，我们正在计划把团队人数增加起来，一起加入做大。 ",
    timeDesc: "4月11日17时28分",
    pov: "澳门特别行政区",
    email: "****6579@qq.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 10,
    rank: 5,
    comments: "买卡之前还在疑惑，为什么会有这么便宜的卡，经过一番了解后才知道，国外真的很多金主需要洗钱，以前的跑分不安全了，所以换成了跑货的形式。到后面正常买卡开始操... ",
    timeDesc: "4月11日17时9分",
    pov: "河北省",
    email: "****inal@163.com",
    avatar: require("../../images/reviews/avatar2.png")
  },

  {
    id: 11,
    rank: 4.5,
    comments: "一直不明白跑货是什么意思，抱着尝试的心态在操作几天后终于明白赚钱原来可以这么简单，现在每天稳定收入大几千块纯利很满足了，也算是另一种形式的财富...",
    timeDesc: "4月8日7时57分",
    pov: "河南省",
    email: "****able@yahoo.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 12,
    rank: 5,
    comments: "后悔知道晚了，原来充值卡洗货这么赚钱，进入门槛又低，只是刚开始做时弄USDT账号有点麻烦，熟悉以后就简单了。目前搞了两个多月，账号一切都正常，看来是比较...",
    timeDesc: "4月7日17时29分",
    pov: "青海省",
    email: "****bled@outlook.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 13,
    rank: 4.5,
    comments: "赌狗上岸全靠跑货了！",
    timeDesc: "4月7日2时11分",
    pov: "台湾",
    email: "****phic@att.net",
    avatar: require("../../images/reviews/avatar4.png")
  },
  {
    id: 14,
    rank: 3.5,
    comments: "很给力的一个跑货网站，以前跑过分，上家跑路之后就一直没有找到好的项目，现在终于又找到了出路。还有感谢的客服耐心帮助我。",
    timeDesc: "4月7日1时58分",
    pov: "湖北省",
    email: "****4658@qq.com",
    avatar: require("../../images/reviews/avatar2.png")
  },
  {
    id: 15,
    rank: 5,
    comments: "如今跑分跑货市场鱼龙混杂，之前被骗了很多次，来这个平台也是想着先试试看，结果给了我意想不到的惊喜！买卡后的卡密没有一张是失效的，全部正常兑换套现。给力给...",
    timeDesc: "4月6日1时35分",
    pov: "新疆维吾尔自治区",
    email: "****atic@sina.com",
    avatar: require("../../images/reviews/avatar3.png")
  },
  {
    id: 16,
    rank: 3.5,
    comments: "，YYDS!!!!",
    timeDesc: "4月5日22时40分",
    pov: "河南省",
    email: "****9288@qq.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 17,
    rank: 5,
    comments: "现在的年轻人都玩抖音短视频，可是真正赚钱的没几个人，的洗货模式一定是小资赚钱发展的趋势，当你看到不要犹豫立即加入。",
    timeDesc: "4月5日2时53分",
    pov: "澳门特别行政区",
    email: "****able@yahoo.com",
    avatar: require("../../images/reviews/avatar2.png")
  },
  {
    id: 18,
    rank: 3.5,
    comments: "给我的第一反应，原来充值卡洗货比跑分更赚钱，从新人LV1现在已经合作了一年时间。相信末来发展会越走越好",
    timeDesc: "4月5日1时14分",
    pov: "辽宁省",
    email: "****nane@sina.com",
    avatar: require("../../images/reviews/avatar1.png")
  },
  {
    id: 19,
    rank: 3.5,
    comments: "这个网站帮助了我从负责累累到财富自由。不解释。",
    timeDesc: "4月4日15时21分",
    pov: "黑龙江省",
    email: "****onal@live.com",
    avatar: require("../../images/reviews/avatar2.png")
  },
  {
    id: 20,
    rank: 4.5,
    comments: "之前我都不会用虚拟货币交易的，看了网站的教程和客服的解答后，成功交易了。实现了跑货赚钱！后面希望越来越顺利",
    timeDesc: "4月2日22时42分",
    pov: "台湾",
    email: "****able@yahoo.com",
    avatar: require("../../images/reviews/avatar1.png")
  }

]
export default arr;



// WEBPACK FOOTER //
// ./src/views/comments/enum.js